export const siteSettings = {
  name: "Alpha Trade Sphere",
  link: "https://alphatradesphere.com",
  email: "support@alphatradesphere.com",
  appLink: "https://app.alphatradesphere.com",
};
